<div class="input-edit-container">
  <div class="header">
    <button class="back-button" (click)="back()">
      <img src="assets/icons/arrow-back.svg" width="24" height="24" [alt]="'common.back' | translate" />
    </button>
    <h2>{{ 'input.edit.title' | translate }}</h2>
  </div>

  <div *ngIf="this.input == null">{{ 'input.edit.not_found' | translate }}</div>

  <div *ngIf="this.input != null" class="input-edit-form">
    <div class="basic-settings">
      <div class="form-group">
      <label for="name">{{ 'input.edit.id' | translate: { id: input.id } }}</label>      
      </div>
      <div class="form-group">
        <label for="name">{{ 'input.edit.name' | translate }}</label>
        <input id="name" type="text" [(ngModel)]="input.name" [placeholder]="'input.edit.name_placeholder' | translate" />
      </div>

      <div *ngIf="!isBtn()" class="form-group">
        <label for="type">{{ 'input.edit.type' | translate }}</label>
        <select id="type" [(ngModel)]="input.type" (change)="updateEvents()">
          <option value="Button">{{ 'input.type.Button' | translate }}</option>
          <option value="Switch">{{ 'input.type.Switch' | translate }}</option>
          <option value="InvertedSwitch">{{ 'input.type.InvertedSwitch' | translate }}</option>
          <option *ngIf="isRCV2()" value="Counter">{{ 'input.type.Counter' | translate }}</option>
        </select></div>
    </div>

    <!-- A counter has no events — it has a scale. One pulse of a water meter is usually
         0.01 m³ (10 L); the controller only counts pulses, the meaning lives here. -->
    <div class="counter-settings" *ngIf="input.type === 'Counter'">
      <h3>{{ 'input.type.Counter' | translate }}</h3>
      <div class="form-group">
        <label for="unit">{{ 'input.edit.unit' | translate }}</label>
        <input id="unit" type="text" [(ngModel)]="input.unit" placeholder="m³, kWh, L…" />
      </div>
      <div class="form-group">
        <label for="pulseValue">{{ 'input.edit.pulse_value' | translate }}</label>
        <input id="pulseValue" type="number" step="any" [(ngModel)]="input.pulseValue"
               placeholder="0.01" />
        <small>{{ 'input.edit.pulse_value_hint' | translate }}</small>
      </div>
      <div class="form-group">
        <label for="counterReading">{{ 'input.edit.current_value' | translate }}</label>
        <input id="counterReading" type="number" step="any" [(ngModel)]="counterReading"
               [placeholder]="'input.edit.reading_placeholder' | translate" />
        <span class="counter-unit">{{ input.unit }}</span>
        <button type="button" (click)="setCounter()">{{ 'input.edit.set_on_controller' | translate }}</button>
        <small>{{ 'input.edit.set_on_controller_hint' | translate: { pulses: counterPulses ?? 0 } }}</small>
      </div>
    </div>

    <h3 *ngIf="input.type !== 'Counter'">{{ 'input.edit.events' | translate }}</h3>

    <div class="events-container" *ngIf="input.type !== 'Counter'">
      <div *ngFor="let event of input.events; let i = index" class="event-card">
        <div class="event-header">
          <h4>{{ 'input.edit.event' | translate }}: {{ 'input.event.' + event.event | translate }}</h4>
        </div>

        <div class="actions-container">
          <div *ngFor="let action of event.actions; let j = index" 
               class="action-card"
               [class.deleting]="isDeleting(i, j)"
               [class.adding]="isAdding(i, j)">
            <ng-container *ngTemplateOutlet="actionCard; context: { $implicit: action, at: { e: i, a: j } }"></ng-container>
          </div>
        </div>

        <button class="add-button" (click)="addAction(i)">
          <img src="assets/icons/plus.svg" width="20" height="20" [alt]="'common.add' | translate" />
          {{ 'common.add_action' | translate }}
        </button>

        <!-- Sequence: each firing runs the next step, after the actions above, wrapping round. -->
        <div class="sequence-container" *ngIf="supportsSequences() || event.sequence?.length">
          <h4>{{ 'input.edit.sequence' | translate }}</h4>
          <div class="sequence-hint" *ngIf="supportsSequences()">{{ 'input.edit.sequence_hint' | translate }}</div>
          <div class="error-message" *ngIf="!supportsSequences()">{{ 'input.edit.sequence_fw_required' | translate }}</div>

          <div *ngFor="let step of event.sequence; let s = index" class="step-card">
            <div class="step-header">
              <span>{{ 'input.edit.step' | translate: { n: s + 1 } }}</span>
              <button class="remove-button" (click)="removeStep(i, s)" [title]="'common.remove_step' | translate">
                <img src="assets/icons/close.svg" width="20" height="20" [alt]="'common.remove' | translate" />
              </button>
            </div>
            <div class="actions-container">
              <div *ngFor="let action of step.actions; let j = index" class="action-card">
                <ng-container *ngTemplateOutlet="actionCard; context: { $implicit: action, at: { e: i, s: s, a: j } }"></ng-container>
              </div>
            </div>
            <button class="add-button" (click)="addStepAction(i, s)">
              <img src="assets/icons/plus.svg" width="20" height="20" [alt]="'common.add' | translate" />
              {{ 'common.add_action' | translate }}
            </button>
          </div>

          <button class="add-button" *ngIf="supportsSequences()" (click)="addStep(i)">
            <img src="assets/icons/plus.svg" width="20" height="20" [alt]="'common.add' | translate" />
            {{ 'common.add_step' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="error-message" *ngIf="formError">{{ formError | translate }}</div>    

    <div class="form-actions">
      <button class="cancel-button" (click)="back()">{{ 'common.back' | translate }}</button>      
      <button class="save-button" (click)="save()">{{ 'common.save' | translate }}</button>
    </div>
  </div>
</div>

<!-- One action's editor: used by an event's actions and by each sequence step. -->
<ng-template #actionCard let-action let-at="at">
  <div class="action-header">
    <div class="action-controls-left">
    </div>
    <button class="remove-button" (click)="removeActionAt(at)" [title]="'common.remove_action' | translate">
      <img src="assets/icons/close.svg" width="20" height="20" [alt]="'common.remove' | translate" />
    </button>
  </div>
  <div class="action-grid">
    <div class="form-group">
      <label>{{ 'common.type' | translate }}</label>
      <select [(ngModel)]="action.type">
        <option value="output">{{ 'common.output' | translate }}</option>
        <option value="alloff">{{ 'common.all_off' | translate }}</option>
        <option value="scenario">{{ 'common.scenario' | translate }}</option>
      </select>
    </div>

    <div class="form-group" *ngIf="action.type === 'output'">
      <label>{{ 'common.output' | translate }}</label>
      <select [(ngModel)]="action.outputEid" (ngModelChange)="onOutputChange(action)">
        <option *ngFor="let output of outputs" [ngValue]="output.eid">
          {{ output.name }}
        </option>
      </select>
    </div>

    <div class="form-group" *ngIf="action.type === 'scenario'">
      <label>{{ 'common.scenario' | translate }}</label>
      <select [(ngModel)]="action.scenarioId">
        <option *ngFor="let scenario of scenarios" [ngValue]="scenario.id">
          {{ scenario.name }}
        </option>
      </select>
    </div>

    <div class="form-group" *ngIf="action.type === 'output'">
      <label>{{ 'common.action' | translate }}</label>
      <select [(ngModel)]="action.action">                  
          <option value="on">{{ 'common.on' | translate }}</option>
          <option value="off">{{ 'common.off' | translate }}</option>
          <option value="toggle">{{ 'common.toggle' | translate }}</option>                  
      </select>
    </div>

    <div class="form-group" *ngIf="action.type === 'scenario'">
      <label>{{ 'common.action' | translate }}</label>
      <select [(ngModel)]="action.action">                  
          <option value="run">{{ 'common.run' | translate }}</option>
          <option value="stop">{{ 'common.stop' | translate }}</option>                    
      </select>
    </div>
  </div>
</ng-template>
